import * as Sentry from "@sentry/browser";

let initialized = false;

export function initSentry() {
  if (typeof window === "undefined" || initialized) return;

  const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    enabled: process.env.NODE_ENV === "production",
    tracesSampleRate: 0.1,
  });
  initialized = true;
}

export function captureException(error, context = {}) {
  if (typeof window === "undefined") return;
  if (!process.env.NEXT_PUBLIC_SENTRY_DSN) return;

  if (!initialized) {
    initSentry();
  }

  Sentry.captureException(error, context);
}
